module.exports = __webpack_public_path__ + "img/navIcon1.d4c9128d.png";